// VERY IMPORTANT!
// Make sure you use descriptive names in the strings, otherwise there will be name clashes.
// In other words, we cannot re-use a name inside a string inside another redux component

export const SET_METADATA_FETCH_DATA = "SET_METADATA_FETCH_DATA",
  API_V1_GET_METADATA_INFO_REQUEST = "API_V1_GET_METADATA_INFO_REQUEST",
  API_V1_GET_METADATA_INFO_SUCCESS = "API_V1_GET_METADATA_INFO_SUCCESS",
  API_V1_GET_METADATA_INFO_FAILURE = "API_V1_GET_METADATA_INFO_FAILURE";
